import React, { useState, useEffect } from "react";
import "../css/modal.css";
import { IoWarningOutline } from "react-icons/io5";
import TelefoneService from "../../modules/services/TelefoneService";

function ModalTelefoneIndividual({ isOpen, onClose, cliente, idTelefone, tipoTelefone, onClienteUpdate }) {
    const [telefone, setTelefone] = useState("");
    const [agree, setAgree] = useState(false);

    // Função para formatar telefone durante a digitação
    const formatarTelefone = (valor) => {
        const apenasNumeros = valor.replace(/\D/g, '');
        if (apenasNumeros.length <= 2) {
            return apenasNumeros ? `(${apenasNumeros}` : '';
        } else if (apenasNumeros.length <= 7) {
            return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2)}`;
        } else if (apenasNumeros.length <= 10) {
            return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 6)}-${apenasNumeros.slice(6)}`;
        } else {
            return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 7)}-${apenasNumeros.slice(7, 11)}`;
        }
    };

    // Atualiza o telefone quando o modal abre ou quando o cliente muda
    useEffect(() => {
        if (isOpen && cliente && idTelefone) {
            const telefoneEncontrado = cliente.telefones?.find(tel => tel.idTelefone === idTelefone);
            const telefoneAtual = telefoneEncontrado?.dsTelefone || "";
            setTelefone(telefoneAtual);
        }
    }, [isOpen, cliente, idTelefone]);

    if (!isOpen) return null;

    const handleSave = async () => {
        if (!agree) {
            alert("Você precisa concordar com os termos.");
            return;
        }

        if (!telefone.trim()) {
            alert("Por favor, informe o telefone.");
            return;
        }

        try {
            const telefoneEncontrado = cliente.telefones?.find(tel => tel.idTelefone === idTelefone);
            const cdTelefone = telefoneEncontrado?.cdTelefone || 0; // Se não existir, usa 0 para cadastrar

            await TelefoneService.atualizarTelefone(
                cliente.cdCliente,
                cdTelefone,
                telefone,
                idTelefone
            );

            alert("Telefone atualizado com sucesso! A alteração pode demorar alguns instantes para ser processada.");
            if (onClienteUpdate) {
                await onClienteUpdate();
            }
            onClose();
        } catch (error) {
            alert("Erro ao atualizar telefone.");
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <div className="topoModal">
                    <button className="modal-close" onClick={onClose}>✖</button>
                    <h3><b>Editar telefone {tipoTelefone}</b></h3>
                </div>
                <p>Digite o novo número de telefone para {tipoTelefone.toLowerCase()}.</p>

                <label><b>Telefone {tipoTelefone.toLowerCase()}</b></label>
                <input
                    type="tel"
                    placeholder="(00) 00000-0000"
                    value={telefone}
                    onChange={(e) => setTelefone(formatarTelefone(e.target.value))}
                    maxLength={15}
                />

                <div className="modal-alert">
                    <IoWarningOutline size={70} />
                    A alteração do telefone será processada e pode demorar alguns instantes para ser efetivada.
                </div>

                <p>O número de telefone é de responsabilidade do informante.</p>

                <div className="modal-checkbox">
                    <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} />
                    <label className="textoAceite">Estou ciente destas obrigações e concordo</label>
                </div>

                <div className="modal-actions">
                    <button className="cancel" onClick={onClose}>Cancelar</button>
                    <button 
                        className={`confirm ${!agree ? 'disabled' : ''}`} 
                        onClick={handleSave}
                        disabled={!agree}
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ModalTelefoneIndividual;

